import { useWeb3React } from '@pancakeswap/wagmi'
import {
  ArrowForwardIcon,
  Box,
  Button,
  Radio,
  Flex,
  Heading,
  Text,
  ButtonMenu,
  ButtonMenuItem,
  CloseIcon,
} from '@pancakeswap/uikit'
import useLocalDispatch from 'contexts/LocalRedux/useLocalDispatch'
import { HistoryFilter } from 'state/types'
import { setHistoryFilter, setHistoryPaneState } from 'state/predictions'
import { useGetHistoryFilter, useGetIsFetchingHistory } from 'state/predictions/hooks'
import { useTranslation } from '@pancakeswap/localization'
import styled, { useTheme } from 'styled-components'

const Filter = styled.label`
  align-items: center;
  cursor: pointer;
  display: inline-flex;
  margin-right: 16px;
`

const StyledHeader = styled(Box)`
  background: ${({ theme }) => theme.colors.modalBg};
  flex: none;
`

const ButtonMenuContainer = styled.div`
  margin-bottom: 16px;
  width: 100%;
  & > div {
    width: 100%;
  }

  & button {
    width: 100%;
  }
  div {
    background: none;
  }
`

const StyledButton = styled(ButtonMenuItem)`
  background: transparent;
  border-top: none;
  border-left: none;
  border-right: none;
  border-radius: 0;
  font-size: 18px;
  font-weight: 500;
  margin-bottom: -1px;
  width: 50%;
`

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
  align-items: center;
  gap: 0px;
  padding: 20px;
  margin: auto auto 20px auto;
  > button {
    &:active {
      box-shadow: 0px 0px 0px 1px ${({ theme }) => theme.colors.alienPurple};
    }
  }
`

interface HeaderProps {
  activeTab: HistoryTabs
  setActiveTab: (value: HistoryTabs) => void
}

export enum HistoryTabs {
  ROUNDS,
  PNL,
}

const Header: React.FC<React.PropsWithChildren<HeaderProps>> = ({ activeTab, setActiveTab }) => {
  const historyFilter = useGetHistoryFilter()
  const isFetchingHistory = useGetIsFetchingHistory()
  const { t } = useTranslation()
  const dispatch = useLocalDispatch()
  const { account } = useWeb3React()

  const handleClick = () => {
    dispatch(setHistoryPaneState(false))
  }

  const handleChange = (newFilter: HistoryFilter) => async () => {
    if (newFilter !== historyFilter) {
      dispatch(setHistoryFilter(newFilter))
    }
  }

  const switchTab = async (tabIndex: number) => {
    setActiveTab(tabIndex)
    await handleChange(HistoryFilter.ALL)()
  }
  const theme = useTheme()

  return (
    <StyledHeader>
      <Flex px='20px' alignItems="center" justifyContent="space-between" 
        style={{borderBottom: `1px solid ${theme.colors.borderModal}`, borderTop: `1px solid ${theme.colors.borderModal}`}}
      >
        <Heading as="h3" size="md">
          {t('History')}
        </Heading>
        <Button onClick={handleClick} variant="text" px="0">
          {/* {t('Close')} */}
          <CloseIcon color="text" width="24px" />
        </Button>
      </Flex>
      <ButtonsContainer>
          <StyledButton isActive={activeTab===HistoryTabs.ROUNDS} onClick={()=>setActiveTab(HistoryTabs.ROUNDS)}>{t('Rounds')}</StyledButton>
          <StyledButton isActive={activeTab===HistoryTabs.PNL} onClick={()=>setActiveTab(HistoryTabs.PNL)}>{t('PNL')}</StyledButton>
      </ButtonsContainer>
      {activeTab === HistoryTabs.ROUNDS && (
        <>
          <Flex alignItems="center" justifyContent='center' mb='20px' width='100%' px='20px'>
              <ButtonMenuItem side='left'
                width='33%'
                isActive={historyFilter === HistoryFilter.ALL}
                disabled={isFetchingHistory || !account}
                onClick={handleChange(HistoryFilter.ALL)}
              >
                {t('All')}
              </ButtonMenuItem>
              <ButtonMenuItem side='center'
                width='33%'
                isActive={historyFilter === HistoryFilter.COLLECTED}
                disabled={isFetchingHistory || !account}
                onClick={handleChange(HistoryFilter.COLLECTED)}
              >
                {t('Collected')}
              </ButtonMenuItem>
              <ButtonMenuItem side='right'
                width='33%'
                isActive={historyFilter === HistoryFilter.UNCOLLECTED}
                disabled={isFetchingHistory || !account}
                onClick={handleChange(HistoryFilter.UNCOLLECTED)}
              >
                {t('Uncollected')}
              </ButtonMenuItem>
          </Flex>
        </>
      )}
    </StyledHeader>
  )
}

export default Header
